import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9e69ee98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attack-diagram" }
const _hoisted_2 = { class: "attack-diagram__lane attack-diagram__lane--forward" }
const _hoisted_3 = {
  key: 0,
  class: "attack-diagram__row-gap"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down attack-diagram__turn-arrow",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "attack-diagram__lane attack-diagram__lane--backward"
}
const _hoisted_7 = {
  key: 2,
  class: "attack-diagram__extras"
}
const _hoisted_8 = { class: "attack-diagram__extras-label" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { getAttackTacticDiagramRows, normalizeAttackTacticId } from '../attack-tactic-map'
import { trAttackTactic } from '../labels'


export default /*#__PURE__*/_defineComponent({
  __name: 'attack-stage-diagram',
  props: {
    hitStages: {}
  },
  setup(__props: any) {

const props = __props

const { t } = useI18n()

const diagramRows = computed(() => getAttackTacticDiagramRows())
const forwardRow = computed(() => diagramRows.value[0] ?? [])
const displayBackwardRow = computed(() => [...(diagramRows.value[1] ?? [])].reverse())

const displayedIds = computed(() => new Set([
  ...forwardRow.value,
  ...(diagramRows.value[1] ?? []),
]))

const hitSet = computed(() => {
  const set = new Set<string>()
  for (const raw of props.hitStages || []) {
    const id = normalizeAttackTacticId(raw)
    if (id) set.add(id)
  }
  return set
})

const extraHitNodes = computed(() =>
  [...hitSet.value].filter((id) => !displayedIds.value.has(id))
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forwardRow.value, (tacticId, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: tacticId }, [
          _createElementVNode("span", {
            class: _normalizeClass(["attack-diagram__node el-card", { 'is-hit': hitSet.value.has(tacticId) }])
          }, _toDisplayString(_unref(trAttackTactic)(_unref(t), tacticId)), 3),
          (index < forwardRow.value.length - 1)
            ? (_openBlock(), _createElementBlock("i", {
                key: `${tacticId}-arrow`,
                class: "el-icon-arrow-right cm-ui-mr5 cm-ui-ml5 attack-diagram__arrow",
                "aria-hidden": "true"
              }))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    (displayBackwardRow.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (displayBackwardRow.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayBackwardRow.value, (tacticId, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: tacticId }, [
              _createElementVNode("span", {
                class: _normalizeClass(["attack-diagram__node el-card", { 'is-hit': hitSet.value.has(tacticId) }])
              }, _toDisplayString(_unref(trAttackTactic)(_unref(t), tacticId)), 3),
              (index < displayBackwardRow.value.length - 1)
                ? (_openBlock(), _createElementBlock("i", {
                    key: `${tacticId}-arrow`,
                    class: "el-icon-arrow-left cm-ui-mr5 cm-ui-ml5 attack-diagram__arrow",
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (extraHitNodes.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('securityEvent.attackTacticExtraHit')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraHitNodes.value, (tacticId) => {
            return (_openBlock(), _createElementBlock("span", {
              key: tacticId,
              class: "attack-diagram__node is-hit"
            }, _toDisplayString(_unref(trAttackTactic)(_unref(t), tacticId)), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})